module.exports = __webpack_public_path__ + "img/social experience.e19c979c.png";